import { Tooltip, TooltipProps } from "@mui/material";
import { makeStyles } from "@mui/styles";

export type TypePlacementTooltip =
	| "bottom"
	| "left"
	| "right"
	| "top"
	| "bottom-end"
	| "bottom-start"
	| "left-end"
	| "left-start"
	| "right-end"
	| "right-start"
	| "top-end"
	| "top-start"
	| undefined;
export interface TooltipComponentProps extends TooltipProps {
	open?: boolean;
	children: any;
	interactive?: boolean;
	title: any;
	placement?: TypePlacementTooltip;
	onClick?: any;
	stylePopper?: any;
	onMouseDown?: any;
	PopperProps?: any;
	style?: any;
	removeArrow?: boolean;
	width?: number | string;
	maxWidth?: number | string;
	backgroundColor?: string;
	onOpen?: any;
	onClose?: any;
}

const useStylesTooltip = makeStyles((theme) => ({
	customTooltip: {
		"&&": {
			color: (props: TooltipComponentProps) => props.color || "#313131",
			backgroundColor: (props: TooltipComponentProps) => props.backgroundColor || "#FFF",
			fontWeight: 500,
			border: "1px solid #dadde9",
			padding: 10,
			fontSize: 12,
			fontFamily: theme.typography.fontFamily,
			width: (props: TooltipComponentProps) => props.width,
			maxWidth: "fit-content",
			wordBreak: "break-all",
			whiteSpace: "wrap",
		},
	},
}));

export default function TooltipComponent(props: TooltipComponentProps) {
	const classesTooltip = useStylesTooltip(props);

	const { stylePopper: _stylePopper, maxWidth: _maxWidth, interactive: _interactive, ...rest } = props;

	return (
		<Tooltip
			open={props.open}
			style={props.style}
			onClick={props.onClick}
			arrow={!props.removeArrow}
			classes={{
				tooltip: classesTooltip.customTooltip,
				popper: props.stylePopper || "",
			}}
			PopperProps={props.PopperProps}
			onMouseDown={props.onMouseDown}
			placement={props.placement}
			onOpen={props.onOpen}
			onClose={props.onClose}
			{...rest}
		>
			{props.children}
		</Tooltip>
	);
}
